import React from "react";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import DateHelper from "../../DateHelper/DateHelper";
import FileUploadGroupBuilder from "../../FileUploadGroupBuilder/FileUploadGroupBuilder";
import { subYears } from "date-fns";

/* global google */

export default class BookingAdditionalInformationCustomerFields extends React.Component {
	constructor(props) {
		super(props);
    this.autocompleteInput = React.createRef();
    this.autocomplete = null;
    this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);

	}

  componentDidMount() {
    this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.current,
        {"types": ["address"]});
    this.autocomplete.addListener('place_changed', this.handlePlaceChanged);
  }

  /*** Render functions ***/

	render() {
    // console.log("form_field_props", this.props)
    return (
      <div className="BookingCustomerFields">
        <label>{I18n.t('guest_information')}</label>
        <hr></hr>   
        <div className="col-md-12" style={{paddingRight: "0px", paddingLeft: "0px"}}>
          {this.renderFormFields()}  
        </div>
      </div>
    );
  }

  renderFormFields() {
    var formFields = this.props.form_fields.sort((a,b) => a.position - b.position).map((form_field, idx) => {
      var form_field_answer = null
      var number_field_answer = null
      var date_field_answer = null
      var address_field_answer = null
      if(this.props.guest_information && this.props.guest_information.answers) {
        var formAnswers = this.props.guest_information.answers
        formAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            if(answer.number_answer) {
              number_field_answer = answer.number_answer
            } else if(answer.date_answer) {
              date_field_answer = answer.date_answer 
            } else if(answer.formatted_address) {
              address_field_answer = answer.formatted_address          
            } else {
              form_field_answer = answer.answer
            }
          }
        })
      }
      var formFieldOptions = form_field.options.map((option, index) => {
        return <option key={index} value={option.option}>{option.option}</option>
      })

      if(form_field.field_type == "text_field_single_line") {
        return (      
          <div className="col-lg-6" key={idx}>
            <div className={"form-group " + this.hasError(form_field.id)}>
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <input className="form-control" name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormField}  />
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "select_box") {
        return (
          <div className="col-lg-6" key={idx}>
            <div className={"form-group " + this.hasError(form_field.id)}>
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <select className="form-control" name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : "please_select_one"} onChange={this.props.onChangeFormField} >
                <option value="please_select_one">{I18n.t("select_ellipsis")}</option>
                {formFieldOptions}
              </select>
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "number_input") {
        return (
          <div className="col-lg-6" key={idx}>
            <div className={"form-group " + this.hasError(form_field.id)}>
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <NumberSpinner
                name='number'
                id={form_field.id}
                onChange={this.props.onChangeFormField}
                value={number_field_answer ?  number_field_answer : ""}
                hasError={this.hasError(form_field.field)}/>
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }
      
      if(form_field.field_type == "Date") {
        date_field_answer && typeof date_field_answer == 'string' ? date_field_answer = DateHelper.parseDateFromBackend(date_field_answer) : null;
        return (
          <div className="col-lg-6" key={idx}>
            <div className={"form-group " + this.hasError(form_field.id)}>
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <DatePickerInput
                  selectedDate={date_field_answer}
                  dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
                  customChangeHandler={this.onChangeDate}
                  customChangeSource="FormField"
                  formFieldID={form_field.id}
                  classNames={this.hasError(form_field.field)}
                  minDate={subYears(new Date(), 100)}
                />
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "text_area_multi_line") {
        return (
          <div className="col-lg-6" key={idx}>
            <div className={"form-group " + this.hasError(form_field.id)}>
              <label style={{whiteSpace: "pre-wrap"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <textarea className="form-control" name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormField}  />
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "phone_number") {
        return (
          <div className="col-lg-6" key={idx}>
            <div className={"form-group " + this.hasError(form_field.id)}>
              <label style={{whiteSpace: "pre-wrap"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <input type="tel" className="form-control" name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormField}  />
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "numbered_scale") {
        var current_rating_answer = []
        if(this.props.rating_answers.length > 0) {
          this.props.rating_answers.map((rating_answer) => {
            if(rating_answer.form_field_id == form_field.id) {
              current_rating_answer = rating_answer
            }
          })   
        } else {
          current_rating_answer = {
            answer: form_field_answer,
            selected: true
          }
        }
          
        return (
          <div className="col-lg-6" key={idx}>
            <div className="form-group">
              <label style={{whiteSpace: "pre-wrap" , paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              {this.renderRatingRangeForm(form_field, current_rating_answer)}
              <br></br>
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "emoji_rating") {
        var current_emoji_answer = []
        if(this.props.emoji_answers.length > 0) {
          this.props.emoji_answers.map((emoji_answer) => {
            if(emoji_answer.form_field_id == form_field.id) {
              current_emoji_answer = emoji_answer 
            }
          })  
        } else {
          current_emoji_answer = {
            answer: form_field_answer,
            selected: true
          }
        }
        return (
          <div className="col-lg-6" key={idx}>
            <div className="form-group">
              <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              {this.renderEmojiRatingForm(form_field, current_emoji_answer)}
              <br></br>
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "signature_generator") {
        if(form_field_answer) {
          return (
            <div className="col-lg-6" key={form_field.id}>
              <div className="form-group">
                <label>{I18n.t('signature_generator')}*</label>
                <input className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormField}  />
                <br></br>
                <textarea className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control signature-generator has-errors" : "form-control signature-generator"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} style={{fontFamily: 'cursive'}} readOnly={true}/>
              </div>
            </div>
          )
        } else {
          return (
            <div className="col-lg-6" key={form_field.id}>
              <div className="form-group">
                <label>{I18n.t('signature_generator')}*</label>
                <input className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormField}  />
              </div>
            </div>
          )
        } 
      }
      if(form_field.field_type == "image") {
        return(
          <div className="col-lg-6" key={form_field.id} style={{padding:'0'}}>
            <FileUploadGroupBuilder nested={true} read_only={false} onChange={this.props.onChangeFileUploadGroup ? this.props.onChangeFileUploadGroup : this.onChangeFileUploadGroup} file_upload_groups={this.props.file_upload_group ? [this.props.file_upload_group] : [{ file_uploads: [] }]} singleFile={true} form_field_id={form_field.id} />
          </div>   
        )
      }
      if(form_field.field_type == "address") {
        return (
          <div className="col-lg-6" key={form_field.id}>
            <div className={"form-group " + this.hasError(form_field.id)}>
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <input  
                type="text" 
                id={form_field.id}
                ref={this.autocompleteInput} 
                name="answers[formatted_address]" 
                value={address_field_answer ?  address_field_answer : ""}
                autoComplete="new-password" 
                className="form-control" 
                onChange={(e) => this.props.onChangeAddress(form_field.id, e)}/>
              {this.renderFieldError(form_field.id)}
            </div>
          </div>
        )
      }     
    });
    return (
      <div className="row">
        {formFields}
      </div>
    );
  }

  renderEmojiRatingForm(form_field, current_emoji_answer) {
      var rating_range = 5
      var rating_range_arr = []
      for(let index = 0; index < rating_range; index++) {
        rating_range_arr.push(index + 1)  
      }
      var rating_range_lines = rating_range_arr.map((rating) => {  
        if(rating_range == 5) {
          if(rating == 1) {
            var list_emoji = <i className="far fa-frown-open fa-2x"></i>
          }
          else if(rating == 2) {
            var list_emoji = <i className="far fa-frown fa-2x"></i>      
          } else if (rating == 3) {
            var list_emoji = <i className="far fa-meh fa-2x"></i>
          } else if (rating == 4) {
            var list_emoji = <i className="far fa-smile fa-2x"></i>      
          } else {
            var list_emoji = <i className="far fa-grin fa-2x"></i>
          }  
        }       
        return (
          <li className={rating == current_emoji_answer.answer && current_emoji_answer.selected == true  ? `selected-emoji-scale-li` : `emoji-scale-li`}  onClick={() => this.props.onChangeSelectedEmoji(rating, form_field)} key={rating}>{list_emoji}</li>
        )
      })  
    if(this.props.rating_range != 'none') {
      return (
        <ul className="emoji-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 
  }
  
  renderRatingRangeForm(form_field, current_rating_answer) {
    if(form_field) {
      var rating_range = parseInt(form_field.rating_scale.rating_range, 10)
      var rating_range_arr = []
      for(let index = 0; index < rating_range; index++) {
        rating_range_arr.push(index + 1)  
      }
      var rating_range_lines = rating_range_arr.map((rating) => {
        if(rating_range == 10) {
          if(rating <= 3){
            var color = "#aa381d"
          } else if (rating > 3 && rating <= 6) {
            var color = "#d18140"
          } else if (rating > 3 && rating <= 6) {
            var color = "#bba350"
          } else {
            var color = "#61a544"
          }
        }
        if(rating_range == 5) {
          if(rating < 3){
            var color = "#aa381d"
          } else if (rating  == 3) {
            var color = "#bba350"
          } else if (rating > 3 && rating <= 6) {
            var color = "#61a544"
          } else {
            var color = "#61a544"
          }
        }      
        return (
          <li className={rating == current_rating_answer.answer && current_rating_answer.selected == true ? "selected-rating-scale-li" : "rating-scale-li"}  onClick={() => this.props.onChangeSelectedRating(rating, form_field)} key={rating} style={{borderColor: color, color:color}}>{rating}</li>
        )
      })
    }
      if(this.props.rating_range != 'none') {
        return (
          <ul className="rating-scale-ul">
            {rating_range_lines}
          </ul>
        )
      } 
    }


  /** Error Handling */

  renderFieldError(name) {
    if (this.props.errors && Object.keys(this.props.errors).includes(name)) {
      return <span className="error">{this.props.errors[name][0]}</span>
    }
  }
  
  hasError(name) {
    if (this.props.errors && Object.keys(this.props.errors).includes(name)) {
      return 'has-error'
    }
  }
  /** Helper function **/

  onChangeDate(date, id) {
    this.props.onChangeFormField({
      target: {
        name: 'date',
        value: date,
        id: id
      }
    });
  }



  handlePlaceChanged() {
    var addressObject = this.autocomplete.getPlace()
    var address = addressObject.address_components
    var customer = this.props.guest_information
    var form_field_address_field_id = this.props.form_field_address_field_id
    for(let i = 0; i < address.length; i++){
      for(let j = 0; j < address[i].types.length; j++){
        if(address[i].types[j] === "street_number") {
          var street_number = address[i].long_name
        }
        if(address[i].types[j] === "route") {
          var route = address[i].long_name
        }
        if(address[i].types[j] === "locality") {
          var city = address[i].long_name
        }
        if(address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name
        }
        if(address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name
        }
        if(address[i].types[j] === "country") {
          var country = address[i].long_name
        }
      }
    }
    var newAddressObject = {
      address_1: street_number ? `${street_number} ${route}` : route,
      formatted_address: addressObject.formatted_address,
      city: city,
      state: state_province,
      country: country,
      postal_code: postal_code,
      form_field_id: form_field_address_field_id
    }

    this.props.form_fields.map((field) => {
      if(field.id === newAddressObject.form_field_id) {
        var found = false;
        if(customer.answers) {
          for(var i = 0, ilen = customer.answers.length; i < ilen; i++) {
            if (customer.answers[i].form_field_id === newAddressObject.form_field_id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          customer.answers.map((answer, idx) => {
            if (answer.form_field_id === newAddressObject.form_field_id) {
              customer.answers[idx] = newAddressObject    
            }
          })
        } else {
          if(!customer.answers) {
            customer.answers = []
          }
          var new_answer = newAddressObject
          customer.answers.push(new_answer)
        }
      }
    })
    this.props.handlePlaceSelect(customer)
  }

}